import { createAuthClient } from 'better-auth/react';
import { twoFactorClient, organizationClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  baseURL: window.location.origin + '/api/auth',
  plugins: [
    twoFactorClient({
      onTwoFactorRedirect() {
        window.dispatchEvent(new CustomEvent('require-2fa'));
      }
    }),
    organizationClient()
  ]
});
